// client/src/utils/openCallerScreen.js
//
// Footer → dashboard window: "open this caller's screen". Works with every
// desktop build (1.0.6+) because it only uses openDashboard and the existing
// cross-window relay (notifySessionChanged), which ignores unknown types.
//
//   - Dashboard window not open yet → it opens on /dashboard?openCall=… and the
//     web app reads the query string (consumeOpenCallFromUrl).
//   - Already open → openDashboard just focuses it, and the relayed
//     'open-call' message tells it which caller to show.

export const OPEN_CALL_MESSAGE = 'open-call';

export function openCallerScreen({ callId, callerNumber, extension }, win = window) {
  const api = win?.electronAPI;
  if (!api?.openDashboard) return false;
  const params = new URLSearchParams();
  if (callId) params.set('openCall', callId);
  if (callerNumber) params.set('phone', callerNumber);
  if (extension) params.set('ext', extension);
  api.openDashboard(`/dashboard?${params.toString()}`);
  api.notifySessionChanged?.(OPEN_CALL_MESSAGE, { callId, callerNumber, extension });
  return true;
}

/** Read (and strip) an ?openCall=… request from the current URL. */
export function consumeOpenCallFromUrl(win = window) {
  const url = new URL(win.location.href);
  const callId = url.searchParams.get('openCall');
  const callerNumber = url.searchParams.get('phone');
  if (!callId && !callerNumber) return null;
  const request = { callId, callerNumber, extension: url.searchParams.get('ext') };
  ['openCall', 'phone', 'ext'].forEach((k) => url.searchParams.delete(k));
  win.history.replaceState(win.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  return request;
}
